import { Injectable } from '@angular/core';
import { PersonalFinanceManagementDialogComponent } from './personal-finance-management-dialog/personal-finance-management-dialog.component';
import { Observable } from 'rxjs';
import { FinanceTips } from '../../services/personal-finance-management/personal-finance-management-bean';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';

@Injectable({
  providedIn: 'root'
})
export class PersonalFinanceManagementDialogService {

  private dialogRef!: MatDialogRef<PersonalFinanceManagementDialogComponent, null>;

  constructor(private srvDialog: MatDialog) { }

  private readonly setDialogConfig = (data: PersonalFinanceManagementTipsDialogConfig) => {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.maxWidth = 800;
    dialogConfig.width = '98%';
    dialogConfig.height = 'auto';
    dialogConfig.panelClass = 'custom-dialog-personal-financial-tips-dialog';
    return dialogConfig;
  };

  public showDialog(tips: FinanceTips, externalSettings: ExternalSettings): Observable<null | undefined> {
    // Close the previous dialog if exist
    if ((this.dialogRef) && (this.dialogRef.getState() == MatDialogState.OPEN)) {
      this.dialogRef.close();
    }

    let config: PersonalFinanceManagementTipsDialogConfig = { tips, externalSettings };
    this.dialogRef = this.srvDialog.open(PersonalFinanceManagementDialogComponent, this.setDialogConfig(config))

    return this.dialogRef.afterClosed();
  }
}


export interface PersonalFinanceManagementTipsDialogConfig {
  externalSettings: ExternalSettings;
  tips: FinanceTips
}